import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function Blog() {
  useSeo(
    "Magazin – Datenschutz & Digitalisierung für Praxen | LAIzyDocu",
    "Praxisnahes Wissen zu DSGVO, digitaler Patientenunterschrift und der Digitalisierung Ihrer Praxis – im LAIzyDocu-Magazin.",
  );

  return (
    <div className="min-h-screen bg-stone-50 text-stone-900">
      <SiteNav />
      <main className="max-w-4xl mx-auto px-6 md:px-10 py-14">
        <Link to="/" data-testid="blog-back-home" className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-700 mb-8">
          <ArrowLeft className="w-4 h-4" /> Zur Startseite
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-emerald-900">Magazin</h1>
        <p className="text-stone-600 mt-3 text-lg max-w-2xl">Praxisnahes Wissen zu DSGVO, Patientenunterschrift und der Digitalisierung Ihrer Praxis.</p>

        <div className="grid gap-5 mt-10">
          {blogPosts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group bg-white rounded-3xl border border-stone-100 p-7 md:p-8 hover:shadow-[0_12px_40px_rgb(0,0,0,0.05)] transition-shadow block">
              <div className="flex items-center gap-2 text-xs text-stone-400 mb-3">
                <span>{new Date(p.date).toLocaleDateString("de-DE")}</span>
                <span className="w-1 h-1 rounded-full bg-stone-300" />
                <span>{p.readingMinutes} Min. Lesezeit</span>
              </div>
              <h2 className="font-display text-2xl font-semibold text-emerald-900 group-hover:text-emerald-700 leading-snug">{p.title}</h2>
              <p className="text-stone-600 mt-2 leading-relaxed">{p.excerpt}</p>
              <div className="flex items-center gap-2 mt-4 flex-wrap">
                {p.tags.map((t) => (
                  <span key={t} className="px-3 py-1 rounded-full bg-emerald-50 text-emerald-800 text-xs font-medium">{t}</span>
                ))}
              </div>
              <span className="inline-flex items-center gap-1 text-emerald-900 font-medium text-sm mt-5">Weiterlesen <ArrowRight className="w-4 h-4" /></span>
            </Link>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
